import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../utils/api";

const initialState = {
  form: null,
  steps: [],
  fields: [],
  plans: [],
  loading: false,
  buttonLoading: false,
  userId: null,
  otpLoading: false,
  email: "",
  isAuthenticated: false,
  plan: {},
  totalDependents: null,
  fileUploading: false,
  getQoute: false,
  flag: false,
  outPatientCare: false,
  dentalCare: false,
  opticalCare: false,
  premiumLoading: false,
  coverPlansLoading: false,
};
const token = localStorage.getItem("token");
const user = sessionStorage.getItem("user");

export const verifyEmail = createAsyncThunk(
  "verifyEmail",
  async ({ email, api }) => {
    try {
      const { data } = await axios({
        method: "POST",
        url: `${baseUrl}/forms/verify-email`,
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify({ email }),
      });
      api.success({
        message: "OTP sent successfully",
      });
      return data;
    } catch (error) {
      console.log(error);
      api.error({
        message: error?.response?.data?.result?.message ?? "Error",
      });
      console.log(error);
    }
  },
);

export const verifyOTP = createAsyncThunk("verifyOTP", async (details) => {
  try {
    const { data } = await axios({
      method: "POST",
      url: `${baseUrl}/user/verify-otp`,
      headers: {
        "content-type": "application/json",
      },
      data: JSON.stringify(details),
    });

    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getForm = createAsyncThunk("getForm", async (_, { dispatch }) => {
  const authToken = localStorage.getItem("token");
  const headers = { "content-type": "application/json" };
  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }
  try {
    const { data } = await axios({
      method: "GET",
      url: `${baseUrl}/forms`,
      headers,
    });

    return data;
  } catch (error) {
    console.log(error);
  }
});

export const getSteps = createAsyncThunk(
  "getSteps",
  async (formId, { dispatch }) => {
    try {
      const { data } = await axios({
        url: `${baseUrl}/forms/${formId}/steps`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const getFields = createAsyncThunk(
  "getFields",
  async ({ formId, stepId }) => {
    const coverageCountry = localStorage.getItem("coverageCountry");
    let params = "";
    if (coverageCountry) {
      params = params + `?region=${coverageCountry}`;
    }
    return await fetch(
      `${baseUrl}/forms/${formId}/steps/${stepId}/fields${params}`,
      {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    )
      .then((res) => res.json())

      .catch((e) => console.log(e));
  },
);

export const getCoverPlans = createAsyncThunk("getCoverPlans", async (body) => {
  const coverageCountry = localStorage.getItem("coverageCountry");

  const { parameters, api } = body;
  let params = "";
  if (coverageCountry) {
    params = params + `?region=${coverageCountry}`;
  }
  try {
    const { data } = await axios({
      url: `${baseUrl}/quote/cover-plans${params}`,
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: JSON.stringify(parameters),
    });
    api.success({
      message: "Plans fetched successfully !",
    });
    return data;
  } catch (error) {
    console.log(error);
    api.error({
      message: error?.response?.data?.result?.message ?? "Error",
    });
  }
});

export const saveStep = createAsyncThunk(
  "saveStep",
  async (body, { dispatch }) => {
    try {
      const { data } = await axios({
        url: `${baseUrl}/quote`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: JSON.stringify(body),
      });
      if (data?.status === 201) {
        dispatch(retreiveValues(body.user_id));
      }
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const updateStep = createAsyncThunk(
  "updateStep",
  async ({ userId, stepId, parameters }, { dispatch }) => {
    try {
      const { data } = await axios({
        url: `${baseUrl}/quote/${userId}/${stepId}`,
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: JSON.stringify({ parameters }),
      });
      if (data?.status === 200) {
        dispatch(retreiveValues(userId));
      }
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const deleteStep = createAsyncThunk("deleteStep", async (userId) => {
  try {
    const { data } = await axios({
      url: `${baseUrl}/quote/${userId}`,
      method: "DELETE",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return data;
  } catch (err) {
    console.log(err);
  }
});

export const retreiveValues = createAsyncThunk(
  "retreiveValues",
  async (userId) => {
    try {
      const { data } = await axios({
        url: `${baseUrl}/quote/${userId}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const calculatePremium = createAsyncThunk(
  "calculatePremium",
  async (options) => {
    const coverageCountry = localStorage.getItem("coverageCountry");
    let params = "";
    if (coverageCountry) {
      params = params + `?region=${coverageCountry}`;
    }
    try {
      const { data } = await axios({
        url: `${baseUrl}/quote/premium${params}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: JSON.stringify(options),
      });
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const getTotalDependents = createAsyncThunk(
  "getTotalDependents",
  async () => {
    const user_id = localStorage.getItem("userId");
    const coverageCountry = localStorage.getItem("coverageCountry");
    let params = "";
    // if (coverageCountry) {
    //   params = params + `?region=${coverageCountry}`;
    // }
    try {
      const { data } = await axios({
        url: `${baseUrl}/quote/${user_id}/dependents${params}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      return data;
    } catch (err) {
      console.log(err);
    }
  },
);

export const uploadFile = createAsyncThunk("uploadFile", async (options) => {
  const token =
    localStorage.getItem("token");
  try {
    const formData = new FormData();
    if (options instanceof FormData) {
      const file = options.get("file");
      if (file) formData.append("file", file);
    } else {
      formData.append("file", options);
    }
    formData.append("document_type", "Quotation_Document");
    formData.append("description", "Upload from sales portal quotation flow");

    const { data } = await axios({
      method: "POST",
      url: `${baseUrl}/document/file`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
    const result = data?.result ?? data?.data ?? data;
    return {
      ...data,
      result: {
        ...result,
        file_id: result?.file_id ?? result?.id ?? result?.document_id,
        file_name: result?.file_name ?? result?.name ?? result?.filename,
      },
    };
  } catch (err) {
    console.log(err);
    throw err;
  }
});

const policySlice = createSlice({
  name: "policySlice",
  initialState: initialState,
  reducers: {
    authenticate: (state, action) => {
      if (
        sessionStorage.getItem("user") &&
        JSON.parse(sessionStorage.getItem("user"))
      ) {
        state.isAuthenticated = true;
      }
    },
    clearSteps: (state, action) => {
      state.steps = [];
    },
    checkQoute: (state) => {
      state.getQoute = true;
    },
    disableQoute: (state) => {
      state.getQoute = false;
    },
    setOutPatientCare: (state) => {
      state.outPatientCare = !state.outPatientCare;
    },
    setDentalCare: (state) => {
      state.dentalCare = !state.dentalCare;
    },
    setOpticalCare: (state) => {
      state.opticalCare = !state.opticalCare;
    },
    enableFlag: (state) => {
      state.flag = true;
    },
  },
  extraReducers(builder) {
    builder.addCase(getForm.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getForm.fulfilled, (state, action) => {
      state.loading = false;
      if (action?.payload) {
        const sortData = action?.payload?.sort(
          (a, b) => a?.sequence - b?.sequence,
        );
        state.form = sortData;
      }
    });
    builder.addCase(getForm.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getSteps.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSteps.fulfilled, (state, action) => {
      state.loading = false;
      state.steps = action?.payload;
    });
    builder.addCase(getSteps.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getFields.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFields.fulfilled, (state, action) => {
      state.loading = false;
      state.fields = action?.payload;
    });
    builder.addCase(getFields.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getCoverPlans.pending, (state) => {
      state.loading = true;
      // state.getQoute = false;
      state.coverPlansLoading = true;
    });
    builder.addCase(getCoverPlans.fulfilled, (state, action) => {
      state.loading = false;
      if (
        action?.payload?.status === 200 &&
        action?.payload?.result &&
        action?.payload?.result?.length > 0
      ) {
        state.plans = action?.payload?.result?.sort((a, b) =>
          a?.coverage_plan?.plan_id.localeCompare(b?.coverage_plan?.plan_id),
        );
        state.getQoute = true;
        state.coverPlansLoading = false;
      }
    });
    builder.addCase(getCoverPlans.rejected, (state, action) => {
      state.loading = false;
      state.getQoute = false;
    });
    builder.addCase(verifyEmail.pending, (state) => {
      state.buttonLoading = true;
    });
    builder.addCase(verifyEmail.fulfilled, (state, action) => {
      state.buttonLoading = false;
    });
    builder.addCase(verifyEmail.rejected, (state, action) => {
      state.buttonLoading = false;
    });
    builder.addCase(verifyOTP.pending, (state) => {
      state.otpLoading = true;
    });
    builder.addCase(verifyOTP.fulfilled, (state, action) => {
      state.loading = false;

      sessionStorage.setItem(
        "user",
        JSON.stringify({
          userId: action?.payload?.result?.user_id,
          email: action?.payload?.result?.email,
        }),
      );
    });
    builder.addCase(verifyOTP.rejected, (state, action) => {
      state.loading = false;
    });
    //
    builder.addCase(saveStep.pending, (state) => {});
    builder.addCase(saveStep.fulfilled, (state, action) => {});
    builder.addCase(saveStep.rejected, (state, action) => {});
    //
    builder.addCase(updateStep.pending, (state) => {});
    builder.addCase(updateStep.fulfilled, (state, action) => {});
    builder.addCase(updateStep.rejected, (state, action) => {});
    //
    builder.addCase(deleteStep.pending, (state) => {});
    builder.addCase(deleteStep.fulfilled, (state, action) => {});
    builder.addCase(deleteStep.rejected, (state, action) => {});
    //
    builder.addCase(retreiveValues.pending, (state) => {
      state.flag = false;
    });
    builder.addCase(retreiveValues.fulfilled, (state, action) => {
      if (action?.payload?.result) {
        sessionStorage.setItem(
          "values",
          JSON.stringify(action?.payload?.result),
        );
        state.flag = true;
      }
    });
    builder.addCase(retreiveValues.rejected, (state, action) => {
      state.flag = false;
    });

    //
    builder.addCase(calculatePremium.pending, (state) => {
      state.premiumLoading = true;
    });
    builder.addCase(calculatePremium.fulfilled, (state, action) => {
      // sessionStorage.setItem("values", JSON.stringify(action?.payload?.result));
      if (action?.payload?.result?.coverage_plan)
        state.plan = action?.payload?.result;
      state.premiumLoading = false;
      sessionStorage.setItem(
        "premium",
        JSON.stringify(action?.payload?.result?.premium_amount),
      );
    });
    builder.addCase(calculatePremium.rejected, (state, action) => {
      state.premiumLoading = false;
    });

    //
    builder.addCase(getTotalDependents.pending, (state) => {});
    builder.addCase(getTotalDependents.fulfilled, (state, action) => {
      if (
        action.payload &&
        action.payload.result &&
        action.payload.result.dependent_count
      )
        state.totalDependents = action.payload.result.dependent_count;
    });
    builder.addCase(getTotalDependents.rejected, (state, action) => {});

    //
    builder.addCase(uploadFile.pending, (state) => {
      state.fileUploading = true;
    });
    builder.addCase(uploadFile.fulfilled, (state, action) => {
      state.fileUploading = false;
    });
    builder.addCase(uploadFile.rejected, (state, action) => {
      state.fileUploading = false;
    });
  },
});

export const {
  authenticate,
  clearSteps,
  checkQoute,
  disableQoute,
  setOutPatientCare,
  setDentalCare,
  setOpticalCare,
  enableFlag,
} = policySlice.actions;

export default policySlice.reducer;
